import NotificationManager from "../Components/Notification2/NotificationManager.js";
import { MESSAGES } from "../Context/LocalizationContext.js";

const ERROR_MESSAGES = {
  // Draft / report creation
  OutOfAllowedPeriodError:
    "Срок сдачи данного отчета истёк. Если необходимо внести изменения — обратитесь к администратору вашей организации.",
  ReportDraftAlreadyCreatedError:
    "Проект отчета по данной форме уже создан. Перейдите в раздел «Проекты отчетов» для продолжения заполнения.",
  ReportAlreadySubmittedError:
    "Отчет по данной форме уже был отправлен ранее. Повторная отправка невозможна.",
  NoSenderDataFoundError:
    "Форма отчетности не найдена. Возможно, она была удалена администратором. Обновите страницу и попробуйте снова.",

  // Report access
  ReportNotFoundError:
    "Отчет не найден. Возможно, он был удалён или перемещён. Обновите страницу.",
  IsNotReportOwner:
    "У вас нет доступа к данному отчету. Убедитесь, что вы вошли под правильной учетной записью.",
  ReportTemplateNotFoundError:
    "Шаблон формы отчетности не найден. Обратитесь к администратору.",

  // Report status
  ReportAlreadyRevoked:
    "Отчет уже был отозван ранее. Повторный отзыв невозможен.",
  DraftNotEditable:
    "Отчет уже принят или находится на проверке. Отзыв и редактирование невозможны.",
  ReportAlreadyRejected:
    "Отчет уже был отклонён. Повторное отклонение невозможно.",

  // Validation / finalization
  NotValidReportError:
    "Отчет содержит ошибки заполнения. Проверьте выделенные красным поля и исправьте данные.",
  ReportDraftStructureError:
    "Структура отчета повреждена. Попробуйте создать новый проект отчета или обратитесь к администратору.",

  // Auth / permissions
  ActingAsRequired:
    "Для выполнения данного действия необходимо выбрать респондента. Выберите респондента в верхней панели.",
  insufficientRightsError:
    "У вас недостаточно прав для выполнения данного действия. Обратитесь к администратору.",
  AuthorizationError:
    "Сессия истекла или недействительна. Закройте все вкладки ESEP, войдите заново и откройте форму снова.",
  NoAuthorizationTokenError:
    "Вы не авторизованы. Войдите в систему и повторите действие.",
  IPAddressMismatchError:
    "Сессия привязана к другому IP (VPN или смена сети). Выйдите, войдите заново и не переключайте VPN, пока заполняете форму.",

  // Input errors
  queryError:
    "Не все обязательные поля заполнены. Проверьте введённые данные и попробуйте снова.",

  // Respondent
  RespondentNotFoundError:
    "Сведения о респонденте не найдены в системе. Обратитесь к администратору.",

  // Login / auth
  UserNotFoundError:
    "Пользователь не найден в системе. Проверьте правильность имени пользователя или обратитесь к администратору.",
  IncorrectPasswordError:
    "Неправильный пароль. Проверьте раскладку клавиатуры и повторите попытку. После нескольких неудачных попыток обратитесь к администратору для сброса пароля.",
  ForcePasswordResetError:
    "Необходимо сбросить пароль. Следуйте инструкциям на экране для создания нового пароля.",
  OldPasswordIncorrectError:
    "Неправильный старый пароль. Убедитесь, что вводите текущий пароль, а не новый.",
  PasswordReusedError:
    "Новый пароль не может совпадать с предыдущими паролями. Придумайте другой пароль.",
  PKIValidationError:
    "Ошибка проверки электронной цифровой подписи (ЭЦП). Убедитесь, что ключ ЭЦП актуален и повторите попытку.",
  SignatureValidationError:
    "Ошибка проверки электронной цифровой подписи (ЭЦП). Убедитесь, что ключ ЭЦП актуален и повторите попытку.",
  LegacyPkiLoginDisabledError:
    "Вход по ЭЦП обновлён. Обновите страницу и повторите вход с электронной цифровой подписью.",
  EdsSignatureRequiredError:
    "Отчет необходимо подписать электронной цифровой подписью сотрудника организации.",
  WrongCertificateRoleError:
    "Выбран неподходящий сертификат. Для отправки отчета нужен ключ ЭЦП этой организации: сотрудник или руководитель.",
  CertificateExpiredError:
    "Срок действия сертификата ЭЦП истёк. Обновите ключ в НУЦ РК и повторите попытку.",
  CertificateRevokedError:
    "Сертификат ЭЦП отозван. Используйте действующий ключ.",
  TestCertificateNotAllowedError:
    "Тестовый сертификат нельзя использовать в рабочей системе. Войдите с боевым ключом НУЦ РК.",
  InvalidCmsError:
    "Подпись недействительна. Повторите подписание.",
  SignedDataMismatchError:
    "Подпись относится к другому документу. Сохраните отчет и подпишите его заново.",
  SignerIinMismatchError:
    "ИИН в сертификате не совпадает с учетной записью. Войдите под своей учетной записью.",
  SignerBinMismatchError:
    "БИН в сертификате не совпадает с организацией респондента.",
  RespondentTransferRequired:
    "ИИН уже привязан к другой организации. Подтвердите перенос на организацию из ключа.",
  SigningSessionExpiredError:
    "Сессия подписания истекла. Начните подписание заново.",
  SigningSessionConsumedError:
    "Эта сессия подписания уже использована. Если отчет не отправился — повторите подписание.",
  DraftVersionConflictError:
    "Проект отчета изменился после начала подписания. Сохраните данные и подпишите снова.",
  TspRequiredError:
    "Не удалось получить метку времени (TSP). Повторите подписание позже.",
  RevocationCheckUnavailableError:
    "Недоступна проверка отзыва сертификата (OCSP/CRL). Повторите попытку позже.",
  VerifierUnavailableError:
    "Сервис проверки ЭЦП временно недоступен. Повторите попытку позже.",
  SigningSessionInProgressError:
    "Подписание этого отчета уже выполняется. Дождитесь завершения или повторите через несколько минут.",
  UntrustedIssuerError:
    "Сертификат выдан не Национальным удостоверяющим центром РК.",
  UserLockedError:
    "Учетная запись заблокирована. Обратитесь к администратору.",
  NcaLayerUnavailable:
    "Не удалось подключиться к NCALayer. Установите или запустите приложение с https://ncl.pki.gov.kz/.",
  NcaLayerLnaDenied:
    "Браузер не разрешил доступ к локальной сети для NCALayer. Разрешите Local Network Access и повторите.",
  IsNotReportDraftOwner:
    "У вас нет доступа к данному проекту отчета. Убедитесь, что вы вошли под правильной учетной записью.",

  // Support tickets
  TicketNotFoundError:
    "Тикет не найден. Возможно, он был удалён. Обновите страницу и попробуйте снова.",
  AttachmentNotFoundError:
    "Вложение не найдено. Возможно, оно было удалено. Обновите страницу.",
  AttachmentTooLargeError:
    "Размер файла превышает 5 МБ. Уменьшите изображение или прикрепите другой файл.",
  TooManyAttachmentsError:
    "К одному тикету можно прикрепить не более 5 файлов. Удалите лишние и попробуйте снова.",
  InvalidAttachmentTypeError:
    "Можно прикреплять только изображения (PNG, JPG, GIF, WebP). Попробуйте другой файл.",
  SubjectTooLongError:
    "Тема обращения слишком длинная (максимум 250 символов). Сократите текст темы.",
  ContactRequiredError:
    "Укажите хотя бы один способ связи — email или номер WhatsApp.",
  InvalidEmailError:
    "Некорректный email. Проверьте правильность написания (например: name@example.com).",
  InvalidWhatsappError:
    "Некорректный номер WhatsApp. Укажите номер в формате +7 777 000 00 00.",
  InvalidSettingsError:
    "Настройки должны быть объектом JSON (ключ-значение), а не массивом или примитивом.",
  UserNotFoundError:
    "Пользователь не найден в системе. Обратитесь к администратору.",

  // Network / server
  UndefinedError:
    "Произошла непредвиденная ошибка на сервере. Попробуйте повторить действие через несколько минут. Если ошибка повторяется — обратитесь к администратору.",
  NetworkError:
    "Нет связи с сервером. Проверьте подключение к интернету и попробуйте снова.",
};

// Resolves with the component's `t` when given, else by the stored locale (ru fallback).
function tr(key, t, vars) {
  if (t) return t(key, vars);
  let loc = "ru";
  try { loc = localStorage.getItem("esep.locale") || "ru"; } catch (e) { /* ignore */ }
  const entry = MESSAGES[key];
  let s = entry ? (entry[loc] ?? entry.ru ?? key) : key;
  if (vars) s = s.replace(/\{(\w+)\}/g, (m, n) => (vars[n] !== undefined ? vars[n] : m));
  return s;
}

/**
 * Returns a user-friendly error message for the given error code in the current locale.
 * Pass the component's `t` for reactive locale; otherwise the stored locale is used.
 */
export function getErrorMessage(code, t) {
  if (ERROR_MESSAGES[code]) return tr(`OthErr_${code}`, t);
  return tr("OthErrGeneric", t, { code });
}

/**
 * Handles an axios error by showing a descriptive notification.
 * Returns the error code (or null) for additional logic in the caller.
 */
export function showApiError(err, t) {
  if (!err?.response) {
    NotificationManager.error(getErrorMessage("NetworkError", t));
    return null;
  }

  const code = err.response?.data?.errorCode;
  NotificationManager.error(getErrorMessage(code || "UndefinedError", t));
  return code;
}

export default ERROR_MESSAGES;
